import { fetchWrapper } from '../../_helpers/fetch-wrapper';
const baseUrl = `${import.meta.env.VITE_API_URL}/batch`;

function useAsyncBatch() {

    async function checkStatus(batchId) {
        return await fetchWrapper.get(`${baseUrl}/${batchId}/status`)
    }

    return { checkStatus }
}

export default useAsyncBatch;